import { Injectable } from '@angular/core';
import { ApiService } from '@uranda/commons';


@Injectable({
  providedIn: 'root'
})
export class VisitorsService extends ApiService {

  async createVisitor(email: string): Promise<any> {
    return this.post('/v1/visitors/create', { email: email }
    );
  }

}
